<template>
  <Bar
    :chart-id="'barChart'"
    :options="chartOptions"
    :data="chartData"
    :plugins="plugins"
  />
</template>

<script>
  import { Bar } from 'vue-chartjs';
  import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, Colors } from 'chart.js';

  import ChartDataLabels from 'chartjs-plugin-datalabels';

  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, Colors);

  export default {
    name: 'BarChart',
    components: { Bar },
    props: {
      labels: {
        type: Array,
        required: true,
      },

      datasets: {
        type: Array,
        required: true,
      },

      title: {
        type: String,
        default: '',
      },

      formatValue: {
        type: Function,
        default: (v) => v,
      },
    },

    data: () => ({
      bgColor: {
        id: 'customCanvasBackgroundColor',
        beforeDraw: (chart, _args, options) => {
          const { ctx } = chart;
          ctx.save();
          ctx.globalCompositeOperation = 'destination-over';
          ctx.fillStyle = options.color || 'white';
          ctx.fillRect(0, 0, chart.width, chart.height);
          ctx.restore();
        },
      },
    }),

    computed: {
      chartData() {
        return {
          labels: this.labels,
          datasets: this.datasets,
        };
      },

      chartOptions() {
        return {
          responsive: true,
          maintainAspectRatio: false,

          plugins: {
            colors: {
              forceOverride: true,
            },

            title: {
              display: true,
              text: this.title,
            },

            legend: {
              position: 'top',
            },

            datalabels: {
              display: false,
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const label = context.dataset.label || '';
                  const value = context.raw;

                  return `${label}: ${this.formatValue(value)}`;
                },
              },
            },
          },

          scales: {
            x: {
              stacked: false,
            },
            y: {
              beginAtZero: true,
              ticks: {
                callback: (value) => this.formatValue(value),
              },
            },
          },
        };
      },

      plugins() {
        return [ChartDataLabels, this.bgColor];
      },
    },
  };
</script>
